<div class="s09-panel s09-dsig">
  <div class="s09-panel-head">
    <div>
      <h2>Data signals</h2>
      <p class="s09-panel-sub">
        Reference dictionary of trigger labels, extract fields, feeds, and known gaps.
      </p>
    </div>
  </div>

  <p class="s09-panel-hint" *ngIf="hint">{{ hint }}</p>
  <p class="s09-panel-hint" *ngIf="loading">Loading data signals…</p>

  <div class="s09-dsig-table-wrap" *ngIf="!loading && items.length">
    <table class="s09-dsig-table">
      <thead>
        <tr>
          <th>Trigger</th>
          <th>Signals in extracts</th>
          <th>Source / feed</th>
          <th>Gap or note</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of items">
          <td class="s09-dsig-trigger">{{ row.trigger_label }}</td>
          <td>{{ row.signals_text }}</td>
          <td>{{ row.source_feed || '—' }}</td>
          <td class="s09-dsig-gap">{{ row.gap_note || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
